"use client";

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";
import NextTopLoader from "nextjs-toploader";
import { Toaster } from "../ui/sonner";
import ClarityScript from "../analytics/ClarityScript";
import TabTrackerProvider from "./TabTrackerProvider";

const Provider = ({ children }: { children: React.ReactNode }) => {
  const [queryClient] = useState(
    () =>
      new QueryClient({
        defaultOptions: {
          queries: {
            refetchOnWindowFocus: false,
            refetchOnMount: false,
            refetchOnReconnect: false,
            retryOnMount: false,
            retry: false,
            staleTime: 30 * 60 * 1000,
          },
        },
      }),
  );

  return (
    <>
      <Toaster />
      <NextTopLoader
        color="#0D9695"
        initialPosition={0.08}
        crawlSpeed={200}
        height={6}
        crawl={true}
        showSpinner={true}
        easing="ease"
        speed={200}
        shadow="0 0 10px #0D9695,0 0 5px #0D9695"
        zIndex={1600}
      />
      <ClarityScript />
      <QueryClientProvider client={queryClient}>
        <TabTrackerProvider>{children}</TabTrackerProvider>
      </QueryClientProvider>
    </>
  );
};

export default Provider;
